<template>
    <div class="container">
        <div class="main" style="font-size: 14px;">
            <div class="title" style="text-align:center;font-size: 20px;font-weight: bold"> DIXCEL中国佛山分仓投入试运营!华南地区当日到货、次日到货成为现实! </div>
            <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2023-04-17</div>
            <div style="line-height:30px">
                <div style="text-align:center;font-size: 20px;font-weight: bold">

                    <el-image  style="width:60%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_17/1.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-align:center;">4月17日，DIXCEL中国佛山分仓</div>
                <div style="text-align:center;">进入试运营阶段。</div>
                <div style="text-align:center;">DIXCEL中国佛山分仓是DIXCEL中国</div>
                <div style="text-align:center;">首次尝试与经销商合作</div>
                <div style="text-align:center;">依托DIXCEL中国自主开发的</div>
                <div style="text-align:center;">ERP系统与DIXCEL ONLINE经销商</div>
                <div style="text-align:center;">采购平台的强大功能</div>
                <div style="text-align:center;">独立运营管理的集入库、出库、盘点等功能</div>
                <div style="text-align:center;;margin-bottom:20px">于一体的仓库合作项目。</div>
                <div style="text-align: center">
                    <el-image  style="width:70%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_17/2.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-indent:30px;margin-bottom:20px">作为DIXCEL中国佛山分仓的官方合作商：佛山市敬龙汽车服务有限公司（后文略称：JL敬龙）将承担分仓的日常管理等工作。
                    长久以来，JL敬龙作为DIXCEL中国华南第一大经销商，不仅为DIXCEL中国在华南市场的发展做出了巨大贡献，也为此次官方合作奠定了坚实的基础。</div>

                <div style="text-align: center">
                    <el-image  style="width:70%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_17/3.jpg')"
                               fit="fit">
                    </el-image>
                </div>
                <div style="text-align: right;margin-right: 130px">左：JL敬龙总经理江敬龙先生  </div>
                <div style="text-align: right;margin-right: 130px;margin-bottom:20px">右：DJHOLDINGS社长井田雅彦先生  </div>

                <div style="text-indent:30px;;margin-bottom:20px">佛山的地理优势也是DIXCEL中国选择JL敬龙的另一个重要原因。佛山与广州、深圳、珠海等广东省核心区域遥相辉映，
                    便捷的交通、成熟的物流体系便于DIXCEL产品迅速延伸到华南乃至全国的各个角落。华南地区的“当日到货”、“次日到货”即将成为现实。</div>

                <div style="text-align: center">
                    <el-image  style="width:70%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_17/4.jpg')"
                               fit="fit">
                    </el-image>
                </div>

                <div style="text-indent:30px;margin-bottom:20px">佛山分仓的建立，将更进一步地维护与开拓华南市场，让华南的客户更快获得所需产品，
                    大大节省运输时间与运输成本，从而抓住稍纵即逝的终端消费意欲，在提升客户购买体验的同时也将提升DIXCEL经销商的成交率与利润。</div>

                <div style="text-indent:30px;margin-bottom:20px">佛山分仓的库存数量、产品类型与DIXCEL中国上海总仓相比将毫不逊色。
                    与上海总仓接近1:1的库存数量，并根据华南市场的热卖车型等特点制定的库存计划、每月补货计划将使得DIXCEL产品在华南市场更具优势。
                    也意味着DIXCEL中国整体库存数量的倍增，以往容易断货、货期较长等原因造成的客户流失问题也将得到一定程度的改善。</div>

                <div style="text-align: center">
                    <el-image  style="width:70%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_17/5.jpg')"
                               fit="fit">
                    </el-image>
                </div>

                <div style="text-indent:30px;margin-bottom:20px">依托自主开发的“DIXCEL ONLINE经销商采购平台”强大的功能，DIXCEL经销商可在下单过程中
                    选择“就近发货”，“整车套发货”等逻辑，并可查询到上海总仓与佛山分仓的库存情况，根据自身和客户的需求合理规划和分配物流成本及物流时间，
                    最大限度地提升客户体验。</div>


                <div style="text-indent:30px;margin-bottom:20px">另一层面，分仓合作模式彻底解决了以往经销商因压货压力、资金周转等原因所造成的库存不足、
                    系列不全（特别是高价产品）等问题，全面提升合作商的服务品质及利润空间。</div>


                <div style="text-align: center">
                    <el-image  style="width:70%;margin-bottom:20px"
                               :src="require('@/assets/image/moment/newsActivitiesPage/2023_04_17/6.jpg')"
                               fit="fit">
                    </el-image>
                </div>

                <div style="text-align:center;">DIXCEL中国佛山分仓库存</div>
                <div style="text-align:center;">将于近期陆续到货入库</div>
                <div style="text-align:center;;margin-bottom:20px">敬请期待！</div>
                <div style="text-indent:30px;">DIXCEL中国佛山分仓的建立仅仅是DIXCEL中国“10年计划”中的第一步，
                    不久之后我们将逐步开启第三分仓、第四分仓等项目，期待遇见更多的“JL敬龙”与我们携手迈向成功。</div>
                <div style="text-align: right">迪库盛贸易（上海）有限公司</div>
                <div style="text-align: right">2023年4月17日</div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return{

            }
        }
    }
</script>

<style lang="stylus" scoped>



    .container
        background-color : #000
        .box_one
            width: 100%;

        .box_bottom
            width: 100%;
            background-color #000


    .main {
        margin-bottom: 5px;
        width: 1003px;
        background-color: #fff;
        margin: 0 auto;
        position: relative;
        box-sizing: border-box;
        padding: 62px 50px 52px;
    }
    .title {
        color :#ab191d;
        text-align:center;
        margin-bottom 10px
    }

</style>
